<div class="overlay" *ngIf="(showOverlay$| async)">
    <div class="spinner-wrapper">
        <mat-spinner></mat-spinner>
    </div>
</div>

<div *ngIf="(tenant$ | async) as tenant" class="main-view-wrapper">

    <div class="container-header">

        <app-breadcrumb [showBackButton]="false" [target]="tenant.name"
            [routes]="[{link: '/', title: 'Tenants'}]"></app-breadcrumb>
        <div class="mb-8 flex items-center justify-between">
            <h1 class="main-title">{{tenant.name}}</h1>

            <button mat-button
                (click)="navigateToBlockedAccounts(tenant.id)"
                class="main-vacuum-btn">
                Account blocking
            </button>
        </div>
    </div>


    <div [style.grid-template-columns]="'repeat(' + (cardsLayout$ | async)?.columns + ', auto)' " class="grid-wrapper">
        <div class="grid-item w-full" [class.justify-start]="card.id === '10'"
            [style.grid-column]="(cardsLayout$ | async)?.columns > 1 ? ('span ' + card.cols): ('span ' + 1)"
            *ngFor="let card of (cardsLayout$ | async)?.items;">

            <app-card-container [item]="card">
                <ng-template cardDirective [item]="card"></ng-template>
            </app-card-container>
        </div>
    </div>
</div>
